import { QueryClient } from '@tanstack/react-query';

// Create a query client with optimal defaults for EZHOA app
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes before considering it stale
      staleTime: 5 * 60 * 1000,

      // Keep unused data in cache for 10 minutes
      gcTime: 10 * 60 * 1000,

      // Retry failed requests once
      retry: 1,

      // Don't refetch on window focus (reduces unnecessary API calls)
      refetchOnWindowFocus: false,

      // Don't refetch on mount if data exists
      refetchOnMount: false,

      // Refetch on reconnect
      refetchOnReconnect: true,

      // Throw errors instead of setting them in state (for error boundaries)
      throwOnError: false,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,

      // Throw errors for mutations (better error handling)
      throwOnError: false,
    },
  },
});

// Export helper to invalidate all queries
export const invalidateAll = () => {
  return queryClient.invalidateQueries();
};

// Export helper to clear all cache
export const clearAllCache = () => {
  queryClient.clear();
};
